/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

$(document).ready(function(){

  // JavaScript to be fired on the configurator pages
  
  let configBtn = document.querySelector('#tkd-configurator-btn');                                                  // Find configurator Summary Button
  let picBtn = document.querySelector('#tkd-configurator-pic-btn');                                                 // Find configurator Photo Button
  let configSummaryWrap = document.querySelector('#configurator-summary');
  let configSummary = document.querySelector('#tkd-configurator-choices');
  let bookAppointment = document.querySelector('#tkd-configurator-book-btn');
  let summary = {};                                                                                                 // Declare array to hold the summary of selected layers / sections
  
  /*
  if(picBtn){                                                                                                       // Ensure photo button exists
    picBtn.addEventListener('click', (e) => {                                                                       // Add click listener to photo button
      let store = wpc.getStore(wpc.$config[0].attributes['data-config-id'].value);                                  // Grab the current store
      wpc.buildActivePreviewImage(store,true,e);                                                                    // Trigger photo to download of current selection
    });
  }
  */

  jQuery(document).on('gform_confirmation_loaded', function(e, formId){
    if (formId === 20){
      let store = wpc.getStore(wpc.$config[0].attributes['data-config-id'].value);                                  // Grab the current store
      wpc.buildActivePreviewImage(store,true,e);                                                                    // Trigger photo to download of current selection
    }
  });


  // Showing all collapsibles if they contain gform confirmation or gform validation error
  const configuratorSummary = document.querySelector('#configurator-summary');
  const gformsConfirmation = document.querySelector('#gform_confirmation_message_6');
  const gformsFormAlert = document.querySelector('.gform_validation_error')
  const configForm = document.querySelector('#downloadConfigForm');
  if(configuratorSummary.contains(gformsConfirmation) || configuratorSummary.contains(gformsFormAlert)){
    configuratorSummary.classList.add('active');
    configForm.classList.add('show');
  }

  configForm.addEventListener('shown.bs.collapse', () => {
    configForm.scrollIntoView();
  })

  if(configForm.classList.contains('show')){
    configForm.scrollIntoView();
  }

  
  

  
  if(configBtn){                                                                                                    // Ensure config summary button exists
    configBtn.addEventListener('click', (e) => {                                                                    // Add click listener to summary button
      if(wpc.$config[0].attributes['data-config-id']){                                                              // Ensure configurator is active
        let configID = wpc.$config[0].attributes['data-config-id'].value;                                           // Get current configurator ID
        let configLayers = wpc.getLayers(configID);                                                                 // Get all layers from active configurator
        let namedLayers = [];                                                                                       // Declare array to hold all layers + their names
        let selectedLayers = [];                                                                                    // Decalre array to hold all currently selected layers
  
        picBtn.disabled = false;
        
        Object.keys(configLayers).forEach((key)=>{                                                                  // Loop through all layers
          namedLayers[configLayers[key].uid] = configLayers[key];                                                   // Assign key and value to named layers array
          if(configLayers[key].settings.active){                                                                    // If layer is currently selected
            selectedLayers.push(configLayers[key])                                                                  // Add to selected layers array
          }
        });
        
        selectedLayers.forEach( selectedLayer => {                                                                  // Loop through all selected layers
          let category;                                                                                             // Define array to hold category of layer (parent layers)
          if(selectedLayer.tree.length > 0){                                                                        // If the layer has a parent
            category = selectedLayer.tree[0];                                                                       // Select top most parent and add to array
          }
          if(category){                                                                                             // If category is set
            if(namedLayers[category].name.toLowerCase() !== 'base kitchen'){                                        // And layer isn't the base kitchen
              summary[namedLayers[category].name] = selectedLayer;                                                  // Assign the category name and layer object to summary array
            }
          }
        });                                                                       
  
        if(configSummary){
          configSummary.innerHTML = '';
          Object.entries(summary).forEach(([key, value]) => {
            configSummary.innerHTML += `
            <div class="col-12 col-md-6 col-lg-4 col-xl-3 tkd-configurator-summary__choices-item">
              <h5 class="variation-type">${key}</h5>
              <div class="variation-details">
                <p class="variation-name">${value.name}</p>
                <span class="variation-preview" style="background-color:${value.settings.color}"></span>
              </div>
            </div>
            `;
          });
        }
  
        configSummaryWrap.classList.add('active');

        window.scroll({
          top: configSummary.offsetTop - 150,
          left: 0,
          behavior: 'smooth',
        }); 
      }else{ console.warn('WARNING: Kitchen Planner is either not present or not initialised. Please try modifying a selection.'); } //Add warning to console if it ain't gonna work
    });
  }
  
 if(bookAppointment){
    bookAppointment.addEventListener('click', (e) => {
      e.preventDefault();
      bookAppointment.disabled = true;
      let kitchenType = document.querySelector('#kitchen-config-type').innerText;
      let store = wpc.getStore(wpc.$config[0].attributes['data-config-id'].value);
      let configID = store.configID;
      let maxWidth = wpc.entireWidth - wpc.minLeft;
      let maxHeight = wpc.entireHeight - wpc.minTop;
      let $elemCon = $('[data-configurator][data-config-id="' + configID + '"] .active [data-preview-inner]').clone();
      let type = $elemCon.data('type');
      let $el = $('<div />', { id: 'screenshot-con', 'data-config-id': configID, 'data-type': type }).html($elemCon.html());

      $el.width(maxWidth - 80).height(maxHeight - 80);
      $el.find('[data-hotspot]').remove();
      $el.appendTo('body');

      wpc.loadPreview(false, $el);

      wpcHtml2Canvas($el[0], {scale : 0.75}).then((canvas) => {
        let dataUrl = canvas.toDataURL('image/jpeg');
        let img = new Image();
        img.src = dataUrl;
        return img;
      }).then((img) => {
        let $thumbnail = $('<div />', { id: 'tkd-thumbnail', class: 'd-none' }).html(img);
        $thumbnail.appendTo('body');
        $($thumbnail).imagesLoaded(function () {
          $el.remove();

          $.ajax({
            url : tkd_configurator.ajax_url,
            data : {
              'action' : 'tkd_submit_config_post',
              'params' : {
                'kitchen_type' : kitchenType,
                'kitchen_options' : JSON.stringify(Object.entries(summary)),
                'kitchen_image' : document.querySelector('#tkd-thumbnail > img').src,
              },
            },
            type : 'POST',
            beforeSend : function(xhr){
              bookAppointment.disabled = true;
            },
            success : function( data ){
              var dataParsed = JSON.parse(data);
              // console.log(dataParsed);
              if(dataParsed !== '0'){
                let appointmentForm = bookAppointment.attributes['data-target-url'].value + '?kitchen_config=' + dataParsed;
                window.location = appointmentForm;
              }
            },
          });
        
          return true;
        });
      });
    });
  }



  //Position style button dynamically for mobile browsers
  // const styleBtnReposition = () => {
  //   if(window.innerWidth < 1024){
  //     const styleBtnHeight = window.innerHeight * 0.965;
  //     $('.style-btn').attr('style', `top: ${styleBtnHeight}px !important`);
  //   }
  // }

  // window.addEventListener('load', styleBtnReposition);
  // window.addEventListener('resize', styleBtnReposition);

  //Position style button for mobile browsers
  const styleBtnReposition = () => {
    if(window.innerWidth < 1024){
      const wpcPreviewInnerHeight = document.querySelector('.wpc-preview-inner').offsetHeight;
      $('.style-btn').attr('style', `top: ${wpcPreviewInnerHeight}px !important`);
    }
    if(window.innerWidth > 1024){
      $('.style-btn').attr('style', 'top: unset');
    }
  }

  window.addEventListener('load', styleBtnReposition);
  window.addEventListener('resize', styleBtnReposition);

  
  //Open/Close the config menu on click
  $('.style-btn').on('click', function() {
    $('.config-menu').addClass('open');
    $('.wrap').addClass('menuOpen');
    $('button.style-btn').addClass('hide');
  });
  $('.config-menu .config-menu__title .close-btn').on('click', function() {
    $('.config-menu').removeClass('open');
    $('.wrap').removeClass('menuOpen');
    $('button.style-btn').removeClass('hide');
  });
  
  $(function() {
    //Simulate window resize on swatch click
    $('.wpc-control-item').on('click', function() {
      $(window).trigger('resize');
    });
  
    //CLose mobile popup notice when the understand button is clicked
    $('.popup-notice .close-btn').on('click', function() {
      $('.popup-notice').css('display', 'none');
    });
  
    //Remove margin from bottom of config sidebar
    $('.wpc-configurator-wrap .wpc-summary')[0].style.setProperty('margin-bottom', '0', 'important');
  
  });
});